import { Module } from 'vuex';
import { RootState } from '../types/index';
import {
  InterfaceState,
  InterfaceActionsKeys,
  InterfaceMutationsKeys,
  InterfaceGettersKeys,
  InterfaceActionsPayload,
  InterfaceMutationsPayload,
  ActiveItem,
} from '../types/interface';
import { StageActionsKeys } from '../types/stageState';

const initState = () => {
  const state: InterfaceState = {
    activeItem: ActiveItem.POINTER,
    laserPointerActive: false,
    sidebarWidth: 16,
    openRightSidebar: false,
  };
  return state;
};

const Interface: Module<InterfaceState, RootState> = {
  state: {
    ...initState(),
  },
  actions: {
    [InterfaceActionsKeys.CHANGE_ACTIVE_ITEM]: ({ commit }, params: InterfaceActionsPayload['CHANGE_ACTIVE_ITEM']) => {
      commit(InterfaceMutationsKeys.CHANGE_ACTIVE_ITEM, params);
    },
    [InterfaceActionsKeys.CHANGE_LASER_ACTIVE]: (
      { commit },
      payload: InterfaceActionsPayload['CHANGE_LASER_ACTIVE']
    ) => {
      commit(InterfaceMutationsKeys.CHANGE_LASER_ACTIVE, payload);
    },
    [InterfaceActionsKeys.CHANGE_SIDEBAR_WIDTH]: (
      { commit },
      payload: InterfaceActionsPayload['CHANGE_SIDEBAR_WIDTH']
    ) => {
      commit(InterfaceMutationsKeys.CHANGE_SIDEBAR_WIDTH, payload);
    },
    [InterfaceActionsKeys.SET_RIGHT_SIDEBAR]: (
      { commit, dispatch },
      payload: InterfaceActionsPayload['SET_RIGHT_SIDEBAR']
    ) => {
      if (payload) {
        dispatch(StageActionsKeys.SET_UNSEEN_SHOUTS, false);
      }
      commit(InterfaceMutationsKeys.SET_RIGHT_SIDEBAR, payload);
    },
    [InterfaceActionsKeys.RESET_STATE]: ({ commit }) => {
      commit(InterfaceMutationsKeys.INTERFACE_RESET_STATE);
    },
  },
  mutations: {
    [InterfaceMutationsKeys.CHANGE_ACTIVE_ITEM]: (state, payload: InterfaceMutationsPayload['CHANGE_ACTIVE_ITEM']) => {
      state.activeItem = payload;
    },
    [InterfaceMutationsKeys.CHANGE_LASER_ACTIVE]: (
      state,
      payload: InterfaceMutationsPayload['CHANGE_LASER_ACTIVE']
    ) => {
      state.laserPointerActive = payload;
    },
    [InterfaceMutationsKeys.CHANGE_SIDEBAR_WIDTH]: (
      state,
      payload: InterfaceMutationsPayload['CHANGE_SIDEBAR_WIDTH']
    ) => {
      state.sidebarWidth = payload;
    },
    [InterfaceMutationsKeys.SET_RIGHT_SIDEBAR]: (state, payload) => {
      state.openRightSidebar = payload;
    },
    [InterfaceMutationsKeys.INTERFACE_RESET_STATE]: state => {
      Object.assign(state, initState());
    },
  },
  getters: {
    [InterfaceGettersKeys.interfaceActiveItem]: state => state.activeItem,
    [InterfaceGettersKeys.interfaceLaserActive]: state => state.laserPointerActive,
    [InterfaceGettersKeys.sidebarWidth]: state => state.sidebarWidth,
    [InterfaceGettersKeys.openRightSidebar]: state => state.openRightSidebar,
  },
};

export default Interface;
